module.exports = __webpack_public_path__ + "static/img/关于我们配图-04.1b2888e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们配图-04.jpg
// module id = 2M9P
// module chunks = 1